import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Nav, Row, Tab } from "react-bootstrap";
import SubAdmin from "./component/SubAdmin";
import add_new from "../../../Assets/svg/add_new.svg";
import { get, updateToken } from "../../../helpers/api_helper";
import { useSelector } from "react-redux";
import NewRoleModal from "./component/Modal/NewRole";
import RoleTable from "./component/roleTable";
import NewSubAdmin from "./component/Modal/NewSubAdmin";
import useCheckPermission from "../../../hooks/useCheckPermission";

const SystemAdmin = () => {
  const [showRoleModal, setShowRoleModal] = useState(false);
  const [showSubAdminModal, setShowSubAdminModal] = useState(false);
  const [modalMode, setModalMode] = useState("create");
  const [roleData, setRoleData] = useState([]);
  const [rolesLoading, setRolesLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("Roles");

  const fetchRole = useCallback(async () => {
    try {
      setRolesLoading(true);
      const response = await get("/roles/list");
      if (response?.success) {
        setRoleData(response?.data);
      }
      setRolesLoading(false);
    } catch (error) {
      console.log("An error occurred while fetching roles", error);
      setRolesLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRole();
  }, [fetchRole]);

  const handleAddNewRole = () => {
    setModalMode("create");
    setShowRoleModal(true); // Show NewRoleModal
  };

  const handleAddNewSubAdmin = () => {
    setModalMode("create");
    setShowSubAdminModal(true); // Show NewSubAdmin modal
  };

  return (
    <>
      <NewRoleModal
        show={showRoleModal}
        onHide={setShowRoleModal}
        handleRefresh={fetchRole}
        mode={modalMode}
      />
      <NewSubAdmin
        show={showSubAdminModal}
        onHide={setShowSubAdminModal}
        handleRefresh={fetchRole}
        mode={modalMode}
      />
      <section className="systemAdmin position-relative py-2">
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-start sectionHeader justify-content-between gap-10 flex-wrap filterBtns">
                <div className="left">
                  <h5 className="m-0 fw-sbold">Users</h5>
                  <p className="m-0 text-muted py-1">
                    It is a long established fact that a reader will be
                    distracted by the readable
                  </p>
                </div>
                {useCheckPermission("subAdmin", "CREATE") && <div className="right">
                  {activeTab === "Roles" ? (
                    <Button
                      onClick={handleAddNewRole}
                      className="d-flex align-items-center justify-content-center rounded-pill btn-custom"
                    >
                      Add New Role{" "}
                      <span className="icn ms-2">
                        <img src={add_new} alt="Add New" />
                      </span>
                    </Button>
                  ) : (
                    <Button
                      onClick={handleAddNewSubAdmin}
                      className="d-flex align-items-center justify-content-center rounded-pill btn-custom"
                    >
                      Add New User{" "}
                      <span className="icn ms-2">
                        <img src={add_new} alt="Add New" />
                      </span>
                    </Button>
                  )}
                </div>}
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="Roles"
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
              >
                <Nav
                  variant="pills"
                  className="transparentBtn-Tab underlineTab py-2 gap-10"
                >
                  <Nav.Item>
                    <Nav.Link
                      eventKey="Roles"
                      className="p-0 bg-transparent position-relative px-2"
                    >
                      Roles
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="Sub-admin"
                      className="p-0 bg-transparent position-relative px-2"
                    >
                      Users
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content className="mt-3">
                  <Tab.Pane eventKey="Roles">
                    <RoleTable
                      data={roleData?.items}
                      fetchRoles={fetchRole}
                      isLoading={rolesLoading}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="Sub-admin">
                    <SubAdmin />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SystemAdmin;
